import clsx from 'clsx';
import { memo, useState, useCallback } from 'react';

import { BrandLogo, VARIANTS } from '@sportsbook/common/components/brand-logo/brand-logo';
import { FooterCopyright } from '@sportsbook/common/components/footer/footer-copyright/footer-copyright';
import { FooterLicense } from '@sportsbook/common/components/footer/footer-license/footer-license';
import { FooterNav } from '@sportsbook/common/components/footer/footer-nav/footer-nav';
import { FooterPartnersList } from '@sportsbook/common/components/footer/footer-partners/footer-partners';
import { Image } from '@sportsbook/common/components/image/image';
import { Divider } from '@sportsbook/common/components/page-content/components/divider/divider';
import { useConfig } from '@sportsbook/common/context/config-provider';
import { useMdxComponent } from '@sportsbook/common/hooks/use-mdx-component';
import { getCurrentYear } from '@sportsbook/common/utils/date';

import { FooterSeeMoreButton } from './footer-see-more-button/footer-see-more-button';

import './footer.scss';

export function FooterUI() {
  const { footer } = useConfig();
  const [payments, partners, responsibly] = footer?.partners || [];
  const [paymentsShown, setPaymentsShown] = useState(false);
  const [partnersShown, setPartnersShown] = useState(false);
  const disclaimer = useMdxComponent(footer?.extra?.[0]?.value, { year: () => getCurrentYear() });

  const handlePartnersClick = useCallback(() => {
    setPartnersShown(prev => !prev);
  }, []);

  const handlePaymentsClick = useCallback(() => {
    setPaymentsShown(prev => !prev);
  }, []);

  return (
    <footer className="sb-Footer">
      <div className="sb-Footer-content">
        <div className="sb-Footer-logos">
          <BrandLogo className="sb-Footer-logo" height={20} variant={VARIANTS.NORMAL} />
        </div>

        <FooterNav />
      </div>

      <Divider className="sb-Footer-divider" />
      <div className="sb-Footer-partners">
        <div className="sb-Footer-list">
          <div className="sb-Footer-label">{payments?.label}</div>
          <FooterPartnersList
            className={clsx('sb-Footer-partnersList', { isExpanded: paymentsShown })}
            partners={payments?.items}
          />
          <FooterSeeMoreButton isExpanded={paymentsShown} onClick={handlePaymentsClick} />
        </div>

        <Divider className="sb-Footer-divider" />

        <div className="sb-Footer-list">
          <div className="sb-Footer-label">{partners?.label}</div>
          <FooterPartnersList
            className={clsx('sb-Footer-partnersList', { isExpanded: partnersShown })}
            partners={partners?.items}
          />
          <FooterSeeMoreButton isExpanded={partnersShown} onClick={handlePartnersClick} />
        </div>
      </div>

      <Divider className="sb-Footer-divider sb-Footer-dividerPartners" />
      <div className="sb-Footer-extra">
        <FooterCopyright isWithLicense={false} />
        <div className="sb-Footer-responsibly">
          <div className="sb-Footer-responsiblyWrapper">
            <FooterLicense />
            <Image className="sb-Footer-responsiblyImage" src={responsibly?.items[0]?.logo?.url} noProxy />
          </div>
          <div>{disclaimer}</div>
        </div>
      </div>
    </footer>
  );
}

export const Footer = memo(FooterUI);
